import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Card } from './ui/Card';
import { Reveal } from './ui/Reveal';
import { Users, ShieldCheck, Globe, BookOpen } from 'lucide-react';
const boards = [{
  name: 'Defense Science Board',
  role: 'Advisor',
  icon: ShieldCheck
}, {
  name: 'Army Science Board',
  role: 'Advisor',
  icon: Users
}, {
  name: 'Defense Management Institute',
  role: 'Fellow',
  icon: BookOpen
}, {
  name: 'NATO DIANA Advisory',
  role: 'Member',
  icon: Globe
}, {
  name: 'Enterprise Governance',
  role: 'Risk Oversight',
  icon: ShieldCheck
}];
export function BoardsSection() {
  return <Section id="boards" variant="navy" data-id="element-64">
      <SectionHeader title="Board & Advisory" subtitle="Governance & Oversight" data-id="element-65" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-66">
        {boards.map((board, i) => <Reveal key={i} delay={i * 100} data-id="element-67">
            <Card className="flex items-center gap-4 hover:border-gold-500 transition-colors h-full" data-id="element-68">
              <board.icon className="text-gold-500 w-8 h-8 flex-shrink-0" data-id="element-69" />
              <div data-id="element-70">
                <h4 className="text-white font-bold uppercase text-sm" data-id="element-71">
                  {board.role}
                </h4>
                <p className="text-slate-400 text-sm" data-id="element-72">{board.name}</p>
              </div>
            </Card>
          </Reveal>)}

        <Reveal delay={500} data-id="element-73">
          <Card className="flex items-center justify-center gap-4 border-dashed border-white/20 bg-transparent h-full" data-id="element-74">
            <p className="text-slate-400 text-sm text-center uppercase tracking-widest" data-id="element-75">
              Available for Corporate Board Service
            </p>
          </Card>
        </Reveal>
      </div>
    </Section>;
}